import React from 'react';
import { Button } from '@mui/material';
import { Forum as ChatIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { useChat } from '../../contexts/ChatContext';
import { findSparesChannel } from '../../utils/chatChannelTypes';

/**
 * Links to the league's spares chat. Renders nothing unless the signed-in user belongs to it
 * (it must be in their chat channel list, which only holds channels they can open).
 */
const OpenSparesChatButton = ({ leagueId, fullWidth = false, sx }) => {
  const { channels } = useChat();
  const channel = findSparesChannel(channels, leagueId);
  if (!channel) return null;

  return (
    <Button
      component={RouterLink}
      to={`/chat/${channel.id}`}
      variant="outlined"
      size="small"
      startIcon={<ChatIcon />}
      fullWidth={fullWidth}
      sx={sx}
    >
      Open Spares Chat
    </Button>
  );
};

export default OpenSparesChatButton;
